import { RECEIVE_DEFAULT_PASSWORD_CONFIGURATION } from '../constants/ActionTypes';

const utilities = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_DEFAULT_PASSWORD_CONFIGURATION:
      return {
        ...state,
        defaultPasswordConfiguration: action.payload,
      };
    default:
      return state;
  }
}

export default utilities;



// WEBPACK FOOTER //
// ./src/reducers/utilities.js